export const entityCardMessages = {
  noImageAvailable: 'No image available',
} as const;
